module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-27.17274003.png";